import { useSessionStore } from "../../../store/useSessionStore";
import DBTInterrupt from "./DBT";

const InterruptComp = () => {
  const interruptAction = useSessionStore.use.interruptAction();
  return (
    <>
      <DBTInterrupt interruptAction={interruptAction} />
    </>
  );
};

export default InterruptComp;
